import { AlertCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useWorkspaceNavigation } from "@/hooks/use-workspace-navigation";

interface SubscriptionLimitModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SubscriptionLimitModal({
  open,
  onOpenChange,
}: SubscriptionLimitModalProps) {
  const { navigate } = useWorkspaceNavigation();

  const handleUpgrade = () => {
    onOpenChange(false);
    navigate("/settings/billing");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-destructive" />
            <DialogTitle>Subscription Limit Reached</DialogTitle>
          </div>
          <DialogDescription className="pt-3 text-left">
            Deal limit in your subscription plan has been reached. Upgrade your
            plan to use more features.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleUpgrade}>See Plans</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
